<script lang="ts">
    import { deviceSize } from "@utils/material/responsive"
    import type { ScaleParams, SlideParams } from "svelte/transition"
    import { scale, slide, fade } from "svelte/transition"
    import {
        closeBottomPopup,
        bottomPopupShowing,
        queue,
        componentStore,
        bottomPopupOpen,
    } from "@components/bottomPopup/bottomPopup.module"
    import { animating } from "@utils/directives/useAnimating"
    import Icon from "@components/material/Icon.svelte"
    import { clickEnter } from "@utils/directives/accessibility"

    const selectedTransition = (
        node: HTMLElement,
        args?: SlideParams & ScaleParams
    ) => {
        return $deviceSize != "desktop" ? slide(node, args) : scale(node, args)
    }

    function finishedAnimation() {
        bottomPopupShowing.set(false)
        if (queue.length) {
            componentStore.set(queue.shift())
            bottomPopupOpen.set(true)
        }
    }
</script>

{#if $bottomPopupOpen}
    <div
        class="bottompopup-backdrop"
        on:pointerup={closeBottomPopup}
        transition:fade|global
        on:outroend={finishedAnimation}
    />

    {#if $componentStore}
        <div class="bottomPopupContainer" aria-modal="true">
            <div
                class="bottomPopup secondaryFont"
                transition:selectedTransition|global
                use:animating
            >
                <div class="bottomClose">
                    <right>
                        <div
                            class="close"
                            tabindex="0"
                            aria-label="close"
                            role="button"
                            on:keydown={clickEnter}
                            on:click={closeBottomPopup}
                        >
                            <Icon icon="close" />
                        </div>
                    </right>
                </div>
                <div class="bottomScrollContainer">
                    <svelte:component
                        this={$componentStore.component}
                        {...$componentStore.props}
                    />
                    <div class="spacer" />
                    <!-- Needs a spacer to revert to 1em if ios-bottom isn't there -->
                </div>
            </div>
        </div>
    {/if}
{/if}
